<template lang="html">
  <nav
  :class="{
      hide: !showMenu && $route.name === 'home',
      small: small,
      home: $route.name === 'home'
    }"
  >
      <router-link :to="{ name: 'home' }">
            Aspekt Office
            <!-- <img class="nav-logo" src="/public/assets/aspekt-office-1line-black.svg"/> -->
      </router-link>
      <router-link class="center" :to="{ name: 'projects', params: { id: 'all' } }">Projects</router-link>
      <router-link :to="{ name: 'about' }">Info</router-link>
      <!-- <router-link :to="{ name: 'contact' }">Contact</router-link> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      showMenu: false,
      small: true
    };
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", this.onScroll);
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (window.scrollY > window.innerHeight / 2) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
      if (window.scrollY >= 0) {
        this.small = true;
      } else {
        this.small = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  position: sticky;
  top: 0;
  left: 0;
  padding: 0.5rem 2.5rem 0.65rem 2.5rem;
  width: 100%;
  box-sizing: border-box;
  z-index: 2;
  display: grid;
  grid-gap: var(--lh);
  grid-template-columns: 1fr 1fr 1fr;
  opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  transition: opacity 0.5s, background 0.5s;
  pointer-events: none;
  transform: translate3d(0, 0, 0);
  will-change: auto;
  @media only screen and (max-width: 768px) {
      padding: 0.5rem 0.5rem 0.65rem 0.5rem;
  }
  .center {
      text-align: center;
  }
  &.home {
    position: fixed;
  }
  .nav-logo {
    height: var(--fs);
  }
  a {
    font-size: var(--fs);
  }
  &.small {
      position: fixed;
  }
  &.hide {
    opacity: 0;
  }
  div.right {
      padding-bottom:0.15rem;
  }
  a {
    pointer-events: auto;
    font-family: "Modern-Aspekt-Medium", sans-serif;
    &:last-of-type {
      text-align: right;
    }
  }
}
</style>
